import React, { useRef, useEffect } from 'react';
import { Stack, TextField } from '@mui/material';

function OtpField({
  value = '',
  onChange = () => {},
  length = 6,
  fontSize = '2rem',
}) {
  const inputRefs = useRef([]);

  useEffect(() => {
    const firstEmptyIndex = value.split('').findIndex((x) => x === '');
    const indexToFocus =
      firstEmptyIndex === -1 ? value.length : firstEmptyIndex;
    inputRefs.current[indexToFocus]?.focus();
  }, [value, length]);

  const handleChange = (e, index) => {
    const char = e.target.value;
    if (!isNaN(Number(char)) && char.length <= 1) {
      const newValue =
        value.substring(0, index) + char + value.substring(index + 1);

      onChange(newValue);

      if (char && index < length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      const newValue = `${value.substring(0, index - 1)}${value.substring(index)}`;
      onChange(newValue);
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{ margin: 'unset', padding: '16px' }}
    >
      {Array.from({ length }).map((_, index) => (
        <TextField
          key={`${String(index)}`}
          inputRef={(el) => {
            inputRefs.current[index] = el;
          }}
          value={value[index] || ''}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          slotProps={{
            htmlInput: {
              maxLength: 1,
              style: { textAlign: 'center', fontSize },
            },
          }}
          sx={{
            width: '60px',
            flex: 'none',
            'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button':
              {
                WebkitAppearance: 'none',
                margin: 0,
              },
            'input[type=number]': {
              MozAppearance: 'textfield',
            },
          }}
          variant="outlined"
          type="number"
        />
      ))}
    </Stack>
  );
}

export default OtpField;
